import { Loader2 } from 'lucide-react';
import { cn } from '@/lib/utils';

function Spinner({ small = false, className }: { small?: boolean; className?: string }) {
  return (
    <Loader2 className={cn('animate-spin text-gray-400', small ? 'size-4' : 'size-6', className)} />
  );
}

export default Spinner;
